<script>

import {Loading} from "element-ui";

export default {
  name: "Status",
  data() {
    return {
      loadingOption: {}
    }
  },
  mounted() {
    this.loadingOption = {lock: false,
      spinner: '',
      background: 'rgba(0, 0, 0, 0.7)'};
  },
  methods: {
    show() {
      this.loading = Loading.service(this.loadingOption)
    },
    success(message) {
      this.loading.close();
      this.$message.success(message)
    },
    failed() {
      this.loading.close();
    }
  }
}
</script>
